/**
 * Utility functions for IP address and device information capture
 * Used for legal audit trail (NR-05 compliance)
 */

/**
 * Get user's public IP address
 * Uses ipify.org free API (no API key required)
 * Falls back to unavailable if request fails
 */
export async function getUserIP(): Promise<string> {
  try {
    const response = await fetch("https://api.ipify.org?format=json", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.warn("Failed to fetch IP address from ipify.org");
      return "IP não disponível";
    }

    const data = await response.json();
    return data.ip || "IP não disponível";
  } catch (error) {
    console.warn("Error fetching IP address:", error);
    return "IP não disponível";
  }
}

/**
 * Get user's device information (User Agent)
 * Includes browser, OS, and device information
 */
export function getUserAgent(): string {
  return navigator.userAgent || "User Agent não disponível";
}

/**
 * Get comprehensive audit information
 * Combines IP and User Agent for complete audit trail
 */
export async function getAuditInfo(): Promise<{
  ip: string;
  userAgent: string;
  timestamp: string;
}> {
  const ip = await getUserIP();
  const userAgent = getUserAgent();
  const timestamp = new Date().toISOString();

  return {
    ip,
    userAgent,
    timestamp,
  };
}

/**
 * Format device information for display
 * Extracts readable browser and OS info from User Agent
 */
export function formatDeviceInfo(userAgent: string): string {
  // Extract browser
  let browser = "Desconhecido";
  if (userAgent.includes("Chrome")) browser = "Chrome";
  else if (userAgent.includes("Firefox")) browser = "Firefox";
  else if (userAgent.includes("Safari")) browser = "Safari";
  else if (userAgent.includes("Edge")) browser = "Edge";

  // Extract OS
  let os = "Desconhecido";
  if (userAgent.includes("Windows")) os = "Windows";
  else if (userAgent.includes("Mac")) os = "macOS";
  else if (userAgent.includes("Linux")) os = "Linux";
  else if (userAgent.includes("Android")) os = "Android";
  else if (userAgent.includes("iOS")) os = "iOS";

  return `${browser} em ${os}`;
}
